/**
 * index.ts - Main entry point for the client.
 *
 * Any module imported here or in any sub-import will be included in the main
 * bundle for the web.
 *
 * (!) (!) (!) DO NOT USE THIS FILE FOR ADMIN-ONLY CODE!!! USE index-admin-tools.js (!) (!) (!)
 */

// Next, expose legacy globals. Additional config is in the webpack.config.js.
// ORDER IS IMPORTANT!
import 'jquery';
import 'bootstrap3/dist/css/bootstrap.css';
import 'bootstrap3';
import 'jquery-ui/themes/base/core.css';
import 'jquery-ui/themes/base/autocomplete.css';
import 'jquery-ui/themes/base/datepicker.css';
import 'jquery-ui/themes/base/dialog.css';
import 'jquery-ui/themes/base/draggable.css';
import 'jquery-ui/themes/base/menu.css';
import 'jquery-ui/themes/base/sortable.css';
import 'jquery-ui/themes/base/tooltip.css';
import 'jquery-ui/themes/base/theme.css';
import 'jquery-bootstrap-theme/css/custom-theme/jquery-ui-1.10.3.custom.css';
import 'jquery-ui/ui/widget';
import 'jquery-ui/ui/widgets/autocomplete';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/ui/widgets/dialog';
import 'jquery-ui/ui/widgets/draggable';
import 'jquery-ui/ui/widgets/menu';
import 'jquery-ui/ui/widgets/sortable';
import 'jquery-ui/ui/widgets/tooltip';
import 'notify';
import 'jquery.blockUI';
import 'angular';
import 'angular-ui-bootstrap'; // TODO: Some evidence suggests that this is unused.
import 'angular-route'; // TODO: Verify direct all dependents are not already importing this when needed
import 'angular-utils-pagination/dirPagination';
import 'angular-touch';
import 'tinymce';
import 'bootbox/bootbox';
import 'react';
import 'react-dom';
import 'cropperjs/dist/cropper.min.css';

// Legacy JS files that were moved in from the old PHP asset manager
import '../module/Plugins/RcmShoppingCartImageDisplay/public/image-display';
import 'rcm-js-lib';
import 'rcm-core';
import 'rcm-dialog';
import '../module/rcm-core/core/public/rcm-html-editor/dist/adapter-tinymce/rcm-html-editor.min';
import '../module/rcm-core/core/public/rcm-html-editor/dist/rcm-html-editor.min';
import '../module/rcm-core/switch-user/public/dist/switch-user';
import '../module/rcm/api-lib/public/rcm-api-lib';
import 'pipe-rat-js/dist/pipe-rat-js';

// Legacy CSS files that were moved in from the old PHP asset manager
import '../module/App/public/css/categories.css';
import '../module/App/public/css/shopping-cart.css';
import '../module/rcm-core/core/public/rcm-html-editor/dist/adapter-tinymce/rcm-html-editor.min.css';

// All other modules are last
import 'rcm-ui';
import 'test-mode';
import { AllProductsBlock } from 'block-all-products';
import { BlockRcmAddToCartButtonContainer } from 'block-rcm-add-to-cart-button';
import { DistributorNextStepsDashboardBlock } from '@reliv/distributor-next-steps-dashboard';
import { enableCheckoutAngularRouter } from 'cart-ui';
import { init as globalMaintenanceAlertInit } from 'global-maintenance-alert';
import { init as initAttentiveMobile } from 'attentive-mobile';
import { LoginFormBlock } from '@reliv/login';
import { PasswordResetBlock } from '@rcm/password-reset';
import { ProductDetailPageTopBlock } from '@reliv/product-detail-page-top';
import { PwsOwnerInfoCertifiedDynamicLogo } from '@reliv/pws-owner-info';
import { ReceiptPageContainer } from 'cart-ui-react';
import * as analytics from 'reliv-analytics';
import * as appStateRcm from 'app-state-rcm';
import * as rcmMyProfile from '@rcm/my-profile';
import * as rcmGASettings from '@rcm/ga-settings';
import * as rcmConfig from '@rcm/rcm-config';
import * as rcmSpacerMedium from '@rcm/spacer-medium';
import * as rcmSpacerLarge from '@rcm/spacer-large';
import * as blockCertificationTraining from '@rcm/certification-training';
import * as blockDontHaveAccount from 'block-dont-have-account';
import * as blockDownloadableImage from 'block-downloadable-image';
import * as blockRotatingBannerImage from 'block-rotating-banner-image';
import * as cartUi from 'cart-ui';
import * as cartUiReact from 'cart-ui-react';
import * as cookieNotice from 'cookie-notice';
import * as distributorLinkCreator from '@reliv/distributor-link-creator';
import * as dynamicNavigation from 'dynamic-navigation';
import * as facebookAnalyticsEdit from 'facebook-analytics-edit';
import * as fixedAspectRatioDivReact from '@rcm/fixed-aspect-ratio-div-react';
import * as freeSimpleEventRegistration from '@rcm/free-simple-event-registration';
import * as multiAddToCart from 'block-multi-add-to-cart-client';
import * as productCircle from 'product-circle';
import * as pwsContact from 'pws-contact';
import * as pwsCouponOwnerControls from '@reliv/pws-coupon-owner-controls';
import * as pwsHomePagePopups from 'pws-home-page-popups';
import * as pwsHomePageProducts from 'pws-home-page-products';
import * as pwsHomePageVideo from 'pws-home-page-video';
import * as quickShopWithSections from 'quick-shop-with-sections';
import * as rcmI18n from 'rcm-i18n';
import * as reactBlockRenderer from 'client-react-block-renderer';
import * as returnToTop from 'return-to-top';
import * as searchRatBlocks from 'search-rat-blocks';
import * as signSomeoneUpTool from 'sign-someone-up-tool';
import * as sponsorRcnAffiliateLinks from 'sponsor-rcn-affiliate-links';
import * as suggestedProducts from 'suggested-products';
import Cropper from 'cropperjs';
import initAngularAnchorFixer from 'angular-anchor-fixer';
import getAppState from 'app-state/src/getAppState';

import '@rcm/test-component-consumer';

class RelivWebApp {
  /**
   * Start the web app
   */
  public static main = () => new RelivWebApp();

  /**
   * Application initialization process
   */
  private constructor() {
    Object.assign(window, this.globals);
    sponsorRcnAffiliateLinks.checkForAffiliateLinkInUrl();
    analytics.init();
    initAttentiveMobile();
    initAngularAnchorFixer();
    pwsHomePagePopups.register();
    document.addEventListener('DOMContentLoaded', this.onDOMContentLoaded);
  }

  /**
   * Post-DOM initialization
   */
  public onDOMContentLoaded = () => {
    // TODO: These modules currently require that their loading be
    // delayed until after DOM has been loaded, but ideally we would
    // like load order and timing to work using order-apathetic imports
    // like everything else. Until then we have to use CommonJS to load
    // them so that they can be delayed.
    require('app-ui');
    require('conference-ui');

    appStateRcm.injectIntoRcmConfig();
    dynamicNavigation.tagCurrentMenuItems();
    cookieNotice.renderBanner();
    cartUi.init();
    cartUiReact.init();
    globalMaintenanceAlertInit();
    // console.log('Going to render test component');
    // RcmTestComponentConsumer.render();
  };

  /**
   * Blocks that will be available to the client React block renderer
   */
  get blocks(): reactBlockRenderer.BlockComponentCollection {
    return {
      BlockSiteSearchBox: searchRatBlocks.BlockSiteSearchBox,
      BlockSiteSearchResults: searchRatBlocks.BlockSiteSearchResults,
      CookieSettings: cookieNotice.CookieNoticeSettingsBlock,
      DistributorLinkCreator: distributorLinkCreator.DistributorLinkCreatorBlock,
      RcmResetPassword: PasswordResetBlock,
      RcmMyProfile: rcmMyProfile.MyProfileBlock,
      RcmGASettings: rcmGASettings.GASettingsBlock,
      RcmSpacerMedium: rcmSpacerMedium.SpacerBlockMedium,
      RcmSpacerLarge: rcmSpacerLarge.SpacerBlockLarge,
      ProductCircle: productCircle.ProductCircleBlock,
      PwsContactOwner: pwsContact.ContactFormBlock,
      PwsHomePageProducts: pwsHomePageProducts.PwsHomePageProductsBlock,
      PwsHomePageVideo: pwsHomePageVideo.PwsHomePageVideoBlock,
      QuickShopWithSections: quickShopWithSections.QuickShopBlock,
      RcmAddToCartButton: BlockRcmAddToCartButtonContainer,
      RcmGoogleSearchResults: searchRatBlocks.BlockSiteSearchResults,
      ReturnToTop: returnToTop.ReturnToTopBlock,
      SignSomeoneUpTool: signSomeoneUpTool.SignSomeoneUpToolBlock,
      PwsCouponOwnerControls: pwsCouponOwnerControls.PwsCouponOwnerControlsBlock,
      SuggestedProducts: suggestedProducts.SuggestedProductsV2Block,
      SuggestedProductsV3: suggestedProducts.SuggestedProductsBlock,
      RotatingBannerImage: blockRotatingBannerImage.RotatingBannerImageBlock,
      DontHaveAccount: blockDontHaveAccount.DontHaveAccountBlock,
      DownloadableImage: blockDownloadableImage.DownloadableImageBlock,
      CertificationTraining: blockCertificationTraining.CertificationTrainingBlock,
      FreeSimpleEventRegistration: freeSimpleEventRegistration.RegistrationBlock,
      PwsHomePagePopups: pwsHomePagePopups.PwsHomePagePopupsBlock,
      DistributorNextStepsDashboard: DistributorNextStepsDashboardBlock,
      AllProducts: AllProductsBlock,
      RcmLogin: LoginFormBlock,
      ProductDetailPageTop: ProductDetailPageTopBlock,
    };
  }

  /** @deprecated */
  public inject = (enter: (services: any) => void) =>
    enter({
      'rcm-i18n': rcmI18n,
    });

  /**
   * Variables that will be exposed directly to the global scope
   */
  public globals = {
    BlockMultiAddToCartController: multiAddToCart.BlockMultiAddToCartController,
    FacebookAnalyticsEditController: facebookAnalyticsEdit.FacebookAnalyticsEditController,
    FixedAspectRatioDiv: fixedAspectRatioDivReact.FixedAspectRatioDiv,
    clientReactBlockRenderer: new reactBlockRenderer.default(this.blocks),
    PwsOwnerInfoCertifiedDynamicLogo,
    ReceiptPageContainer,
    enableCheckoutAngularRouter,
    getCheckoutOrderManager: cartUi.getCheckoutOrderManager,
    inject: this.inject,
    Cropper, // Used by PWS image upload process
  };
}

RelivWebApp.main();
